module.exports = {
  app: {
    isIpad:
      "BiP Oyunlar şu an için sadece mobil cihazları desteklemektedir, lütfen mobil cihanız üzerinden deneyin!"
  },
  index: {
    game: "游戏",
    welfare: "福利",
    category: "分类",
    nav: "Oyunlar",
    seek: "Ara",
    lb_title: "Rekabet!",
    lb_text: "geliştir ve ödüllendir",
    lb_button: "ŞİMDİ KATIL !",
    lb_rank: "SIRA",
    lb_prize: "ÖDÜL",
    lb_go: "GİT",
    history_title: "SON OYUN",
    swiper_img: require("@/img/trbanner.jpg"),
    list_button: "ŞİMDİ OYNA",
    player: "Oyuncu",
    recommend: "Daha fazlası yükleniyor",
    nogame: "Başka oyun yok",
    free: require("@/img/free_tr.png"),
    Save: "Kaydet",
    failed: "Kaydedilemedi",
    success: "Başarıyla kaydedildi",
    newimg: require("@/img/tga_new.png"),
    hotimg: require("@/img/tga_hot.png"),
    Share: "Paylaş",
    Sharegame: "Bu oyunu paylaşmak ister misin?",
    open: "Aç",
    More: "fazlası",
    ad: "Reklam"
  },
  rank: {
    title: "Genel Sıralama"
  },
  activity: {
    my_rank: "SIRALAMAM",
    my_points: "PUANLARIM",
    task_name: "GÖREV",
    rank_points: "PUANLAR",
    count: "TOPLAM",
    Treasure_chest: "Sandık",
    info: "BİLGİ",
    rankinh: "SIRALAMA",
    reward: "ÖDÜL",
    everyone: "HERKESE",
    points: "PUAN",
    rules: "KURALLAR",
    Waiting: "Seni Bekliyor",
    point: "PUAN",
    part1: require("@/img/trpart1.png"),
    part2: require("@/img/trpart2.png"),
    Claim: "Aç"
  },

  activity_get: {
    title: "= Kazanmak için oynayın =",
    data_package: "Toplanan veri paketi:",
    time: "Her gün 13:00'da ve 19:00'da deneyin",
    obtain: "Kazan",
    obtained: "Kazandın",
    Redeem: "Ödülleri kullan",
    Edit: "Profili Düzenle",
    event: "Ödülleri etkinlikten sonra kullanın",
    rules: "KURALLAR",
    list: [
      `Shoot'em UP" oynayan oyuncular, veri paketi almak için günlük bir ödül kazanma hakkına sahip olurlar.`,
      `Ödül saat 13:00'da ve 19:00'da aktif olur.`,
      `Oyuncuların kazandıkları veri paketleri etkinliğin sonra ermesiyle yüklenecektir.`,
      `Veri paketi almak için kural dışı yollar kullanan oyuncular diskalifiye edilecektir.`
    ],
    check: "Ödülü al",
    hint: "Ödül alındı. Bir sonraki turu bekleyin.",
    bg_top: require("@/img/trbg_1.jpg")
  },
  game_seek: {
    result: "Sonuç yok",
    play: "oyna",
    Loading: "Daha fazlası yükleniyor"
  },
  site: {
    title: "Bilgileri doldurun",
    site_title: "Ödül almak için lütfen aşağıyı doldurun",
    username: "İsim",
    phone: "Telefon",
    address: "Teslimat adresi",
    site_button: "Onayla",
    successfully: "Yükleme başarıyla tamamlandı",
    failed: "Yükleme başarısız"
  },
  name: {
    Confirm: "Onayla",
    Avatar: "Avatarı Değiştir"
  },
  iosIndex: {
    allgame: "Tüm Oyunlar",
    history_title: "Son Oynananlar"
  },

  config: {
    No_result: "无内容",
    server: "服务器繁忙",
    loading: "加载中",
    no_loading: "到底啦"
  },
  boon: {
    gold: "金币",
    diamond: "钻石",
    sing: "金币记录",
    mysing: "我的金币",
    chekin: "已签到",
    no_chekin: "签到",
    chekin_text: "已连续签到",
    day: "天",
    achievement: "成就中心",
    check: "查看",
    coming_soon: "coming soon",
    gold_mall: "金币商城",
    quest: "每日任务",
    no_complete: "去完成",
    get: "领取",
    complete: "已完成",
    checked: "已签到"
  },
  achievements: {
    gold: "金币",
    diamond: "钻石",
    achievement: "成就",
    get_prize: "领取"
  },
  Pay: {
    Current_Diamonds: "当前钻石",
    Billing_Breakdowns: "帐单明细",
    Topup: "充值",
    Consumption: "消费",
    Successful: "付款成功",
    Failure: "付款失败",
    Result: "结算",
    GO_BACK: "返回",
    abnormity: "您已支付成功，但订单查询异常，请过几分钟后刷新试试。",
    no_goods: "商品已下架",
    Network: "网络异常，请重试。",
    no_google: "谷歌服务无法在你的设备上运行",
    loading: "加载中",
    no_loading: "到底啦",
    // 支付
    Confirm: "确认",
    Pay: "立即支付",
    Loading: "加载中",
    payment: "付款中..."
  },
  goldModal: {
    conversiongold: "兑换金币",
    diamond: "钻石",
    gold: "金币",
    MAX: "最大",
    Pay: "购买"
  },

  estimate: {
    text: "你喜欢这款游戏吗？",
    toast: "评价成功"
  },
  appLogin: {
    text: "请先登录再继续操作",
    login: "去登录",
    loginSuccess: "登录成功",
    loginError: "登录失败"
  },
  appTip: {
    title: "Duyuru",
    text:
      "Planlı bakım çalışması nedeniyle bu sayfada yer alan GNÇ oyunlarında, 22 Temmuz Cumartesi 17:00 - 20:00 (TSİ) saatleri arasında bakım çalışması yapılacaktır. İlgili saatler arasında oyunlara giriş yapılamayacaktır. 22 Temmuz 20:00 sonrası aynı şekilde oynamaya devam edebilirsin 👍.",
    ok: "OK"
  }
};



// WEBPACK FOOTER //
// ./src/assets/common/lang/tr.js